<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 9.svg" alt="" />
        <div class="settings-card__header-headline">
            <h4>Galerie Bulevart</h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section position-relative">
                    <div class="section-top">
                        <h3 class="section-title">Galerie Bulevart</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('auth-module.bulevart.bulevart-gallery.add')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <div class="card-container p-2" *ngIf="showCard">
                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field class="w-100">
                                    <mat-label>Categorie</mat-label>
                                    <mat-select [(ngModel)]="categoryId"
                                        (selectionChange)="onCategorieChange($event.value)">
                                        <mat-option *ngFor="let categorie of categorii" [value]="categorie.id">
                                            {{ categorie.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="w-100">
                                    <mat-label>Subcategorie</mat-label>
                                    <mat-select [(ngModel)]="subcategoryId"
                                        (selectionChange)="onSubcategorieChange($event.value)">
                                        <mat-option *ngFor="let subcategorie of subcategorii$ | async"
                                            [value]="subcategorie.id">
                                            {{ subcategorie.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Categorie terțiară</mat-label>
                                    <mat-select [(ngModel)]="tertiaryCategoryId">
                                        <mat-option *ngFor="let tertiara of categoriiTertiare$ | async"
                                            [value]="tertiara.id">
                                            {{ tertiara.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Activ</mat-label>
                                    <mat-select [(ngModel)]="activeValue">
                                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                                            {{ param.key }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Public</mat-label>
                                    <mat-select [(ngModel)]="publicValue">
                                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                                            {{ param.key }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                        <div class="row w-100">
                            <div class="col d-flex justify-content-start">
                                <button (click)="toggleCard()" type="button"
                                    class="btn btn-sm btn-warning closeBtn">Închide</button>
                            </div>
                            <div class="col buttons-submit">
                                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                    Resetează
                                </button>
                                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                                    Aplică
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 ps-3">
                        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()"
                            [class.active]="showCard">
                            <i class="fa-solid fa-filter"></i> Filtre
                        </button>
                    </div>

                    <div class="table-container">
                        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="row-border hover  w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>